import { ORDER_META_KEY } from "../constants.js";
import { metaContainsKey } from "@cappelendamm/crystallize-utils";
export const isOrderReturned = (order) => {
    return metaContainsKey(order.meta, ORDER_META_KEY.ORDER.RETURN_ORDER_IDS);
};
